import React, { useEffect, useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { getStorage, ref, listAll, getDownloadURL } from "firebase/storage";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Autoplay } from "swiper/modules";
import { useMediaQuery } from "@mui/material";

const PageBanner = ({ bgnone, pageName, title }) => {
  const [imageUrls, setImageUrls] = useState([]);
  const [activeImage, setActiveImage] = useState("");
  const [fadeSlides, setFadeSlides] = useState(2.8);
  const [bannerHeight, setBannerHeight] = useState("450px");
  const [isExpanded, setIsExpanded] = useState("450px");
  const bannerRef = useRef(null);
  const isMobile = useMediaQuery("(max-width:868px)");

  // useEffect(() => {
  //   const observer = new IntersectionObserver(
  //     ([entry]) => {
  //       if (entry.isIntersecting) {
  //         setTimeout(() => setIsExpanded(true), 300);
  //         bannerRef.current.scrollIntoView({
  //           behavior: "smooth",
  //           block: "center",
  //         });
  //       } else {
  //         setIsExpanded(false);
  //       }
  //     },
  //     { threshold: 0.9 }
  //   );

  //   if (bannerRef.current) observer.observe(bannerRef.current);

  //   return () => observer.disconnect();
  // }, []);

  useEffect(() => {
    const fetchAllImages = async () => {
      try {
        const imagesRef = ref(getStorage(), "pagebanner");
        const result = await listAll(imagesRef);
        const urls = await Promise.all(
          result.items.map(async (item) => {
            try {
              return await getDownloadURL(item);
            } catch (error) {
              console.error("Error fetching image:", error);
              return null;
            }
          })
        );

        const validUrls = urls.filter((url) => url !== null).sort();
        setImageUrls(validUrls);
        if (validUrls.length > 0) {
          setActiveImage(validUrls[0]);
        }
      } catch (error) {
        console.error("Error fetching images:", error);
      }
    };

    fetchAllImages();
  }, []);

  const handleSlideChange = (swiper) => {
    if (imageUrls.length > 0) {
      setActiveImage(imageUrls[swiper.realIndex]);
    }
  };
  useEffect(() => {
    let animationFrame;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          const visiblePercentage = Math.max(
            0,
            Math.min(
              1,
              (window.innerHeight - entry.boundingClientRect.top) /
                (entry.boundingClientRect.height + window.innerHeight)
            )
          );

          cancelAnimationFrame(animationFrame);
          animationFrame = requestAnimationFrame(() => {
            setFadeSlides(2.8 - 0.9 * visiblePercentage);
            setBannerHeight(`${450 + 200 * visiblePercentage}px`);
          });
        }
      },
      { threshold: Array.from({ length: 101 }, (_, i) => i / 100) }
    );

    if (bannerRef.current) observer.observe(bannerRef.current);

    return () => {
      cancelAnimationFrame(animationFrame);
      observer.disconnect();
    };
  }, []);

  return (
    <div
      ref={bannerRef}
      style={{
        position: "relative",
        marginTop: !isMobile ? "4px" : "0",
        overflow: "hidden",
        transition: "opacity 0.5s ease",
      }}
    >
      {activeImage && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: !isMobile ? bannerHeight : "300px",
            backgroundImage: `url(${activeImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: isExpanded
              ? "blur(15px) brightness(0.5)"
              : "blur(25px) brightness(0.7)",
            transform: isExpanded ? "scale(1.02)" : "scale(1.08)",
            zIndex: 1,
            transition:
              "height 0.8s ease, transform 0.8s ease, filter 0.6s ease",
          }}
        />
      )}
      <div style={{ position: "relative", zIndex: 2 }}>
        <Swiper
          modules={[Navigation, Autoplay]}
          spaceBetween={12}
          slidesPerView={!isMobile ? fadeSlides : 1}
          autoplay={{
            delay: 3500,
            disableOnInteraction: false,
          }}
          loop={true}
          centeredSlides={true}
          navigation={true}
          onSlideChange={handleSlideChange}
          style={{ width: "100%" }}
        >
          {imageUrls.map((url, index) => (
            <SwiperSlide key={index}>
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  height: !isMobile ? bannerHeight : "300px",
                  transition: "height 0.8s ease",
                }}
              >
                <img
                  src={url}
                  alt={`Banner ${index + 1}`}
                  loading="lazy"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    display: "block",
                  }}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default PageBanner;
